import { Link } from 'react-router-dom';

const competitors = [
  { name: 'Traditional E-commerce Sites', structured: false, price: false, supplier: false, updates: false },
  { name: 'Spreadsheet-based Communities', structured: false, price: false, supplier: false, updates: false },
  { name: 'Dropshipping Product Tools', structured: false, price: true, supplier: false, updates: false },
  { name: 'ItaobuySpreadsheet', structured: true, price: true, supplier: true, updates: true },
];

const headers = ['Platform', 'Structured Data', 'Price Comparison', 'Supplier Filtering', 'Real-time Updates'];

export default function TrustSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        {/* Comparison Table */}
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold bg-secondary-100 text-secondary-700 rounded-full mb-4">
            Competitive Advantage
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3 font-heading">
            How ItaobuySpreadsheet Compares
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            See why structured product data gives you an edge over traditional shopping platforms
          </p>
        </div>

        {/* Table */}
        <div className="overflow-x-auto mb-14">
          <div className="min-w-[640px]">
            <div className="grid grid-cols-5 gap-0 rounded-t-lg overflow-hidden">
              {headers.map((h, i) => (
                <div
                  key={i}
                  className={`px-4 py-3 text-xs font-semibold uppercase tracking-wider ${
                    i === 0
                      ? 'bg-foreground-100 text-foreground-600 text-left'
                      : 'bg-foreground-100 text-foreground-600 text-center'
                  }`}
                >
                  {h}
                </div>
              ))}
            </div>

            {competitors.map((row, i) => {
              const isItaobuy = row.name === 'ItaobuySpreadsheet';
              return (
                <div
                  key={i}
                  className={`grid grid-cols-5 gap-0 border-b border-background-200/70 ${
                    isItaobuy ? 'bg-primary-50/40' : 'bg-background-50'
                  }`}
                >
                  <div className={`px-4 py-3 text-sm font-semibold ${isItaobuy ? 'text-primary-700' : 'text-foreground-700'}`}>
                    {row.name}
                  </div>
                  {[
                    { val: row.structured },
                    { val: row.price },
                    { val: row.supplier },
                    { val: row.updates },
                  ].map((cell, j) => (
                    <div key={j} className="px-4 py-3 text-center">
                      {cell.val ? (
                        <i className="ri-check-line text-accent-500 text-lg"></i>
                      ) : (
                        <i className="ri-close-line text-foreground-300 text-lg"></i>
                      )}
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </div>

        {/* Safety / Trust Block */}
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-10">
          <div className="w-full lg:w-1/2">
            <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-accent-100 mb-4">
              <i className="ri-shield-check-line text-2xl text-accent-600"></i>
            </div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-3 font-heading">
              Is ItaobuySpreadsheet Safe?
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Yes — but transparency is important. We are <strong>not</strong> a seller, we do <strong>not</strong> process payments, and all product data is provided strictly for research and comparison purposes.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-100 text-xs text-foreground-600">
                <i className="ri-information-line text-sm"></i>
                Not a Seller
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-100 text-xs text-foreground-600">
                <i className="ri-lock-line text-sm"></i>
                No Payments Processed
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-100 text-xs text-foreground-600">
                <i className="ri-file-search-line text-sm"></i>
                Research Purposes Only
              </span>
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-xl overflow-hidden aspect-[16/10]">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20composition%20with%20soft%20overlapping%20translucent%20circular%20and%20shield%20like%20shapes%20in%20warm%20cream%20and%20beige%20tones%2C%20conveying%20trust%20safety%20and%20transparency%2C%20gentle%20diffused%20lighting%2C%20clean%20serene%20atmosphere%2C%20subtle%20layered%20gradients%2C%20modern%20European%20design%20aesthetic%2C%20no%20text%2C%20editorial%20quality%2C%20calming%20protective%20visual%20concept%2C%20delicate%20geometric%20forms%20with%20harmonious%20balanced%20composition&width=800&height=500&seq=trust-v2-2026-x1&orientation=landscape"
                alt="ItaobuySpreadsheet safety and transparency"
                title="ItaobuySpreadsheet - Safe & Transparent Data Platform"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}